import React from "react";
import variables from "./insAzureMapsVariables.module.scss";
const defaultColorSet = {
    0: variables.defaultHue0,
    1: variables.defaultHue1,
    10: variables.defaultHue10,
    2: variables.defaultHue2,
    3: variables.defaultHue3,
    4: variables.defaultHue4,
    5: variables.defaultHue5,
    6: variables.defaultHue6,
    7: variables.defaultHue7,
    8: variables.defaultHue8,
    9: variables.defaultHue9
};
const esgColorSet = {
    0: variables.esgHue0,
    1: variables.esgHue1,
    10: variables.esgHue10,
    2: variables.esgHue2,
    3: variables.esgHue3,
    4: variables.esgHue4,
    5: variables.esgHue5,
    6: variables.esgHue6,
    7: variables.esgHue7,
    8: variables.esgHue8,
    9: variables.esgHue9
};
const quartileColorSet = {
    0: variables.quartileHueUnknown,
    1: variables.quartileHueBottom,
    2: variables.quartileHueLowerMid,
    3: variables.quartileHueUpperMid,
    4: variables.quartileHueTop
};
const getFillColor = (colorSet, index) => {
    switch (colorSet) {
        case "quartile":
            return quartileColorSet[index];
        case "esg":
            return esgColorSet[index];
        default:
            return defaultColorSet[index];
    }
};
export const getMarkerIcon = (index, colorSet) => React.createElement("svg", { width: "18", height: "29", viewBox: "0 0 18 29", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("g", { filter: "url(#filter0_f)" },
        React.createElement("ellipse", { cx: "9", cy: "24", rx: "6", ry: "3", fill: "black", fillOpacity: "0.2" })),
    React.createElement("path", { id: "colorDefPath", d: "M18 8.86957C18 13.7681 13.7647 20.8696 9 24C4.23529 20.8696 0 13.7681 0 8.86957C0 3.97104 4.02944 0 9 0C13.9706 0 18 3.97104 18 8.86957Z", fill: getFillColor(colorSet, index) }),
    React.createElement("path", { d: "M17.5 8.86957C17.5 11.1942 16.4871 14.1041 14.8571\n    16.842C13.2954 19.4654 11.2033 21.8698 9 23.3968C6.79673 21.8698\n    4.70462 19.4654 3.14286 16.842C1.51286 14.1041 0.5 11.1942 0.5 8.86957C0.5 4.25404 4.29867 0.5 9 0.5C13.7013 0.5 17.5 4.25404 17.5 8.86957Z", stroke: "black", strokeOpacity: "0.3" }),
    React.createElement("circle", { cx: "9", cy: "9", r: "3", fill: "white" }),
    React.createElement("circle", { cx: "9", cy: "9", r: "3.5", stroke: "black", strokeOpacity: "0.3" }),
    React.createElement("defs", null,
        React.createElement("filter", { id: "filter0_f", x: "1", y: "19", width: "16", height: "10", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
            React.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
            React.createElement("feGaussianBlur", { stdDeviation: "1", result: "effect1_foregroundBlur" }))));
export const symbolLayerIconConfig = [
    "match",
    ["get", "markerIndex"],
    0,
    "marker-icon-0",
    1,
    "marker-icon-1",
    2,
    "marker-icon-2",
    3,
    "marker-icon-3",
    4,
    "marker-icon-4",
    5,
    "marker-icon-5",
    6,
    "marker-icon-6",
    7,
    "marker-icon-7",
    8,
    "marker-icon-8",
    9,
    "marker-icon-9",
    10,
    "marker-icon-10",
    "marker-icon-0"
];
